import { IsString, IsOptional } from 'class-validator';

export default class AutomationHandoffNode {
  id: string;
  name: string;

  @IsString()
  @IsOptional()
  description: string;

  customerId: string;
  selection: string;

  @IsOptional()
  number: string;
}
